import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../index';
import {
  loadSchedulesList,
  createSchedule,
  updateSchedule,
  deleteSchedule,
  resetCreateScheduleApiStatus,
  resetUpdateScheduleApiStatus,
  resetDeleteScheduleApiStatus,
  resetAllApiStatus,
  getScheduleById,
} from './schedulesSlice';
import {
  ListAuditSchedulesRequest,
  CreateAuditScheduleRequest,
  UpdateAuditScheduleRequest,
  GetAuditScheduleRequest,
} from 'src/types/helios/AuditSchedule';

export const useSchedules = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    schedulesList,
    fetchSchedulesApiStatus,
    createScheduleApiStatus,
    updateScheduleApiStatus,
    deleteScheduleApiStatus,
    getSchedulesApiStatus,
  } = useSelector((state: RootState) => state.schedules);

  return {
    schedulesList,
    fetchSchedulesApiStatus,
    createScheduleApiStatus,
    updateScheduleApiStatus,
    deleteScheduleApiStatus,
    getSchedulesApiStatus,
    loadSchedulesList: (params: ListAuditSchedulesRequest) =>
      dispatch(loadSchedulesList(params)),
    getScheduleById: (params: GetAuditScheduleRequest) =>
      dispatch(getScheduleById(params)),
    createSchedule: (params: CreateAuditScheduleRequest) =>
      dispatch(createSchedule(params)),
    updateSchedule: (params: UpdateAuditScheduleRequest) =>
      dispatch(updateSchedule(params)),
    deleteSchedule: (programId: string, scheduleId: string) =>
      dispatch(deleteSchedule({ programId, scheduleId })),
    resetCreateScheduleApiStatus: () => dispatch(resetCreateScheduleApiStatus()),
    resetUpdateScheduleApiStatus: () => dispatch(resetUpdateScheduleApiStatus()),
    resetDeleteScheduleApiStatus: () => dispatch(resetDeleteScheduleApiStatus()),
    resetApiStatus: () => dispatch(resetAllApiStatus()),
  };
};
